import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';

@Component({
  selector: 'app-toast-wrapper',
  templateUrl: './toast-wrapper.component.html',
  styleUrls: ['./toast-wrapper.component.scss'],
  animations: [
    trigger('toastAppearance', [
      transition(':enter', [
        style({
          transform: 'translateY(100%)',
          height: '0'
        }),
        animate(
          '200ms ease-in',
          style({
            transform: 'translateY(0)',
            height: '*'
          })
        )
      ]),
      transition(':leave', [
        style({
          opacity: '1'
        }),
        animate(
          200,
          style({
            opacity: '0'
          })
        )
      ])
    ])
  ]
})
export class ToastWrapperComponent {}
